import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-server",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#getting-started-with-server",
        "aria-label": "getting started with server permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Getting Started with Server`}</h1>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` can spin up a real server that can mock or proxy requests. It can work in your local or a higher environment.
Let's see how to set it up locally for a project:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create an example project and initialized with `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`npm`}</code>{`:`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ `}<span parentName="code" {...{
                "className": "token function"
              }}>{`mkdir`}</span>{` example-app `}<span parentName="code" {...{
                "className": "token operator"
              }}>{`&&`}</span>{` `}<span parentName="code" {...{
                "className": "token builtin class-name"
              }}>{`cd`}</span>{` example-app
$ `}<span parentName="code" {...{
                "className": "token function"
              }}>{`npm`}</span>{` init --yes `}<span parentName="code" {...{
                "className": "token comment"
              }}>{`# defaults will be fine`}</span></code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`@mockyeah/server`}</code></p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ `}<span parentName="code" {...{
                "className": "token function"
              }}>{`npm`}</span>{` `}<span parentName="code" {...{
                "className": "token function"
              }}>{`add`}</span>{` --save-dev @mockyeah/server`}</code></pre></div>
        <p parentName="li">{`or`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ `}<span parentName="code" {...{
                "className": "token function"
              }}>{`yarn`}</span>{` `}<span parentName="code" {...{
                "className": "token function"
              }}>{`add`}</span>{` --dev @mockyeah/server`}</code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create script file and add the source below:`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ `}<span parentName="code" {...{
                "className": "token function"
              }}>{`touch`}</span>{` index.js`}</code></pre></div>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "js"
        }}><pre parentName="div" {...{
            "className": "language-js"
          }}><code parentName="pre" {...{
              "className": "language-js"
            }}><span parentName="code" {...{
                "className": "token keyword"
              }}>{`const`}</span>{` mockyeah `}<span parentName="code" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="code" {...{
                "className": "token function"
              }}>{`require`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="code" {...{
                "className": "token string"
              }}>{`'@mockyeah/server'`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`;`}</span>{`

mockyeah`}<span parentName="code" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="code" {...{
                "className": "token function"
              }}>{`get`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="code" {...{
                "className": "token string"
              }}>{`'/hello-world'`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{` `}<span parentName="code" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{` text`}<span parentName="code" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="code" {...{
                "className": "token string"
              }}>{`'Hello World'`}</span>{` `}<span parentName="code" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="code" {...{
                "className": "token punctuation"
              }}>{`;`}</span></code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the script file with Node`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ node index.js`}</code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open `}<a parentName="p" {...{
            "href": "http://localhost:4001/hello-world"
          }}>{`http://localhost:4001/hello-world`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Profit. You should see "Hello World" returned from your mock server.`}</p>
      </li>
    </ol>
    <p>{`Withe relative URLs like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/hello-world`}</code>{` above, if no mock matches, then `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` will response with a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`404`}</code>{`.`}</p>
    <p>{`But `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` can accept absolute URLs like this:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`https://localhost:4001/https://api.example.com?foo=bar`}</code></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`https://localhost:4001/https://service.example.com/foo/bar`}</code></li>
    </ul>
    <p>{`This makes it easy to simply prepend the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` server URL to your existing API URLs (see `}<a parentName="p" {...{
        "href": "#connect-your-app"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`Connect Your App`}</code></a>{` below).`}</p>
    <p>{`With the `}<a parentName="p" {...{
        "href": "../../Configuration#proxy"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`proxy`}</code></a>{` option, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` will also transparently forward all non-matching requests onto their original URL,
and send the response back to you.
This enables working with real APIs by default, but partially mocking responses for some requests.`}</p>
    <p>{`So if we added this mock:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}>{`mockyeah`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`get`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'https://service.example.com/foo/bar'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  json`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    hello`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'there'`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`Then a request to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`https://localhost:4001/https://service.example.com/foo/bar`}</code>{` would result in a response of
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`{ "hello": "there" }`}</code>{`.`}</p>
    <p>{`But any other request like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`https://localhost:4001/https://api.example.com?foo=bar`}</code>{` would not hit any mocks so it would proxy
to the actual `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`https://api.example.com?foo=bar`}</code>{` endpoint and respond normally (though perhaps with some additional headers from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{`).`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` mockyeah `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'@mockyeah/server'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

mockyeah`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`get`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'https://example./hello-world'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` text`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Hello World'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`fetch`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'https://example.local?ok=yes'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`then`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`async`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter"
          }}>{`res`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` data `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`await`}</span>{` res`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`json`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'data is now { fake: "response" }'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2 {...{
      "id": "connect-your-app",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#connect-your-app",
        "aria-label": "connect your app permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Connect Your App`}</h2>
    <p>{`You can use `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-fetch"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`@mockyeah/fetch`}</code></a>{` to automatically rewrite all `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fetch`}</code>{` requests from your client-side or server-side app or unit tests
to hit your new `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` server. See the `}<a parentName="p" {...{
        "href": "../../Packages/mockyeah-fetch#proxy"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`proxy`}</code></a>{` option.`}</p>
    <p>{`Or you can just manually configure your app's service URLs to point to your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` server.`}</p>
    <h2 {...{
      "id": "cli",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#cli",
        "aria-label": "cli permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`CLI`}</h2>
    <p>{`You can use our command-line interface to start a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` server. See more at `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-cli"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`@mockyeah/cli`}</code></a>{`.
You can also use it to record, play, or play all `}<a parentName="p" {...{
        "href": "../../Suites"
      }}>{`suites`}</a>{` with your `}<a parentName="p" {...{
        "href": "../../Packages/mockyeah-server"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`@mockyeah/server`}</code></a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      